<div class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0"></h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <div class="card" style="width: 100%;">
                <!--MENU SUPERIOR-->

            </div>

            <!-- CONTENT TOOLBAR -->
            <div class="toolbar px-24 py-8">
                <span> </span>
            </div>
            <!-- / CONTENT TOOLBAR -->

            <!-- CONTENT -->

            <div class="content-card mainDiv" style="margin-top: 2%; margin-left: 5%; margin-right: 15%;">
                <div aling="center">
                    <img src="{{urlBanner}}" alt="Logo-Norm35" class="centradoIMG ">
                </div><br>
                <div *ngFor="let datita of info">
                    <p *ngIf=" dataId.id == datita.position ">{{datita.title | translate}}</p>
                </div>
                <div *ngFor="let datita of info">
                    <p *ngIf=" dataId.id == datita.position ">{{datita.subtitle | translate}}</p>
                </div>
                <div *ngFor="let datita of info">
                    <p *ngIf=" dataId.id == datita.position ">{{datita.content | translate}}</p>
                </div>
                <div *ngFor="let datita of info">
                    <p *ngIf=" dataId.id == datita.position ">{{datita.content2 | translate}}</p>
                </div>
                <p>{{ 'WIZARD.GUIA1.def' | translate }}</p>

                <table class="table customTable" style="width: 100%">
                    <tr style="width: 100%">
                        <th scope="col" style="width: 70%">{{'WIZARD.GUIA1.SEC' | translate}}</th>
                        <th scope="col" colspan="1" style="width: 30%">{{'WIZARD.GUIA1.RES' | translate}}</th>
                    </tr>
                </table>
                <table class="customTable2" style="width: 100%">

                    <tbody *ngFor="let datita of preguntas1">
                        <tr>
                            <th style="width: 70%">{{datita.ques | translate}}</th>
                        </tr>

                        <tr *ngFor="let opc of datita.opc">
                            <td style="width: 70%">{{opc.ques | translate}}</td>
                            <td style="width: 15%"></td>
                            <td style="width: 15%"></td>
                        </tr>
                    </tbody>

                </table>



            </div>


            <!--<div *ngIf=" dataId.id == datita.position ">-->




        </div>

        <!-- / CONTENT -->

    </div>
    <!-- / CONTENT CARD -->

</div>
<!-- / CENTER -->a